import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';
import BlogManager from './BlogManager';
import CategoryManager from './CategoryManager';
import CommentManager from './CommentManager';
import ReviewManager from './ReviewManager';
import PortfolioManager from './PortfolioManager';
import SeoTools from './SeoTools';
import AnalyticsDashboard from './AnalyticsDashboard';
import AdminLogin from './AdminLogin';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

const AdminRoutes: React.FC = () => (
  <Routes>
    <Route path="login" element={<AdminLogin />} />
    <Route path="" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
    <Route path="blogs" element={<ProtectedRoute><BlogManager /></ProtectedRoute>} />
    <Route path="categories" element={<ProtectedRoute><CategoryManager /></ProtectedRoute>} />
    <Route path="comments" element={<ProtectedRoute><CommentManager /></ProtectedRoute>} />
    <Route path="reviews" element={<ProtectedRoute><ReviewManager /></ProtectedRoute>} />
    <Route path="portfolio" element={<ProtectedRoute><PortfolioManager /></ProtectedRoute>} />
    <Route path="seo" element={<ProtectedRoute><SeoTools /></ProtectedRoute>} />
    <Route path="analytics" element={<ProtectedRoute><AnalyticsDashboard /></ProtectedRoute>} />
  </Routes>
);

export default AdminRoutes;
